<template>
  <div id="data-participants-list" class="w-full">
    <!-- modal -->
    <vs-popup
      width="300px"
      not-center
      v-model="showCheckinModal"
      class="modal"
      title="Confirmaçao de presença"
      :active.sync="showCheckinModal"
    >
      <!-- Checkin do participante -->
      <participant-checkin
        v-show="true"
        :showCheckinModal="showCheckinModal"
        :data="{ selectedParticipant, caravanist }"
        infinite-scroll-distance="0"
        infinite-scroll-throttle-delay="800"
        @presenceConfirmed="closeCheckinModalAndRefreshParticipantList"
        @photoUpdated="closeCheckinModalAndRefreshParticipantList"
      />
    </vs-popup>

    <p
      class="note"
      v-if="
        participants.length && participants[0].recording.participantsListClosed
      "
    >
      <strong>Obs:</strong> A lista de participantes abaixo já foi encerrada,
      não será possível realizar mais nenhuma ação nela.
    </p>
    <div class="no-records" v-if="participants.length < 1">
      <p>Nenhum participante encontrado</p>
    </div>

    <div id="recordings-participants-list" class="participants-list">
      <vs-card
        class="cardlist-data-recordings"
        :key="indextr"
        v-for="(item, indextr) in participants"
        :class="{
          'bg-card-success': item.status,
          'bg-card-pendent': !item.status,
        }"
      >
        <vs-row vs-direction="row">
          <div class="col-photo-part">
            <div class="cardlist-logo" @click="openCheckinModal(item)">
              <!-- Avatar Col -->

              <div class="logo-container">
                <div class="img-container">
                  <img
                    v-if="item.participant.photo"
                    :src="item.participant.photo"
                    class="square"
                  />
                  <span v-else class="rounded-letter">
                    {{ item.participant.name | firstLetter }}
                  </span>
                  <div
                    :class="
                      isCheckinOk(item)
                        ? 'participant-checkin-ok'
                        : 'participant-checkin-no-ok'
                    "
                  >
                    <i
                      :class="
                        isCheckinOk(item) ? 'fa fa-thumbs-up' : 'fa fa-clock'
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-description-part" @click="openCheckinModal(item)">
            <vs-row class="row-name">
              <span class="participant-name"
                >{{ item.participant.name }}
                {{ item.participant.surname }}</span
              >
            </vs-row>
            <div
              class="cardlist-item"
              :class="{ 'hidden-item': !item.participant.email }"
            >
              <span class="item-title">Email: </span>
              <span class="item-text">{{ item.participant.email }}</span>
            </div>
            <div class="cardlist-item">
              <span class="item-title">Celular: </span>
              <span class="item-text">{{
                item.participant.mobile | formatCelphone
              }}</span>
              <div
                class="deficient-list"
                :class="{ 'hidden-item': !item.participant.specialNeed }"
              >
                <span class="item-title">Necessidade Especial: </span>
                <Span class="item-text"
                  >"{{ item.participant.specialNeed }}"</Span
                >
              </div>
            </div>
          </div>
        </vs-row>
        <div class="cardlist-row">
          <div class="" style="margin-top: 5px">
            <div v-if="item.recording.participantsListClosed === false">
              <vs-row vs-justify="flex-end">
                <div v-if="isCheckinOk(item)"></div>

                <vs-button
                  v-else-if="waitingUpdate[item.participant.id] === true"
                  @click="cancelParticipant(item.participant)"
                  color="warning"
                  type="filled"
                  icon="x"
                >
                  Aguarde...
                </vs-button>
                <vs-button
                  style="padding: 0 8px; height: 30px"
                  @click="cancelParticipant(item.participant)"
                  v-else-if="item.status"
                  color="warning"
                  type="border"
                  icon="close"
                >
                  Cancelar
                </vs-button>

                <vs-button
                  style="
                    border: 1px solid #ddd;
                    color: #000;
                    background-color: #fff !important;
                    padding: 0px 20px;
                    align-items: center;
                    text-align: center;
                    height: 32px;
                  "
                  v-else-if="!item.status"
                  @click="openCheckinModal(item)"
                >
                  <i class="fa fa-thumbs-up" style="margin-right: 4px"></i
                  >Confirmar
                </vs-button>

                <div
                  v-if="
                    waitingUpdate[item.participant.id] !== true && !item.status
                  "
                  class="trash-icon-div"
                  style="margin-left: 5px; height: 30px"
                >
                  <feather-icon
                    @click="confirmParticipantRemotion(item.participant)"
                    icon="Trash2Icon"
                  />
                </div>
              </vs-row>
            </div>
            <div v-else class="item-text">
              <span class="status-text">
                {{ statusText(item.confirmedPresence) }}
              </span>
            </div>
          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import ParticipantCheckin from "./ParticipantCheckin.vue";

export default {
  components: {
    ParticipantCheckin,
  },
  props: {
    data: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      selectedParticipant: null,
      isSearching: false,
      searchField: "name",
      searchTerms: "",
      waitingUpdate: {},
      showCheckinModal: false,
      showContactsModal: true,
    };
  },

  computed: {
    participants() {
      return this.data.participants || [];
    },
    caravanist() {
      return this.data.caravanist || null;
    },
  },
  methods: {
    // esse método é chamado de dentro do modal. Veja o modal acima
    closeCheckinModalAndRefreshParticipantList() {
      this.showCheckinModal = false;
      // Isso vai chamar o método abaixo do arquivo pai
      // o Arquivo pai é a Tab "RecordingDetailsTabPublic.vue"
      console.log("closeCheckinModalAndRefreshParticipantList");
      this.$emit("refreshItems");
    },

    isCheckinOk: (item) => {
      return !!item.status;
    },
    alertNotAllowed(message) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Lista encerrada`,
        text: message,
        acceptText: "OK",
      });
    },

    openCheckinModal(item) {
      this.selectedParticipant = item;
      this.showCheckinModal = true;
    },
    statusText(confirmedPresence) {
      if (confirmedPresence === true) return " Participante presente";
      return " Aguardando confirmação de presença";
    },
    alertClosedList() {
      this.alertNotAllowed(
        `Você não pode executar essa ação pois a lista foi encerrada pelo Administrador.`
      );
    },
    confirmParticipantRemotion(item) {
      if (this.caravanist && this.caravanist.participantListClosedAt) {
        this.alertClosedList();
        return;
      }
      const { name, surname } = item;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Remoção de Participante`,
        text: `Por favor, confirme a remoção do participante "${
          name + " " + surname
        }".`,
        acceptText: "Remover",
        cancelText: "Cancelar",
        accept: () => {
          this.removeParticipant(item);
          this.removeInviteWelcome(item);
        },
      });
    },
    refreshParticipants() {
      if (this.caravanist && this.caravanist.participantListClosedAt) {
        this.alertClosedList();
        return;
      }
      this.$store
        .dispatch("recording/fetchParticipants", {
          recordingId: this.$route.params.id,
          limit: this.data.itemsPerPage,
          offset: (this.data.page - 1) * this.data.itemsPerPage,
        })
        .finally(() => {});
    },
    searchParticipants() {
      this.$store
        .dispatch("recording/searchParticipants", {
          field: this.searchField,
          terms: this.searchTerms,
          limit: this.data.itemsPerPage,
          offset: (this.data.page - 1) * this.data.itemsPerPage,
        })
        .finally(() => {});
    },
    setWaiting(id, status) {
      this.waitingUpdate = Object.assign(
        { ...this.waitingUpdate },
        {
          [id]: status || false,
        }
      );
    },
    confirmParticipant(item) {
      if (this.caravanist && this.caravanist.participantListClosedAt) {
        this.alertClosedList();
        return;
      }
      this.setWaiting(item.id, true);
      this.$store
        .dispatch("recording/confirmParticipant", {
          recordingId: this.$route.params.id,
          participantId: item.id,
        })
        .finally(() => {
          this.toastMsg(`Você confirmou a participação de "${item.name}"!`);
          this.setWaiting(item.id, false);
        });
    },
    cancelParticipant(item) {
      if (this.caravanist && this.caravanist.participantListClosedAt) {
        this.alertClosedList();
        return;
      }
      this.setWaiting(item.id, true);
      this.$store
        .dispatch("recording/cancelParticipant", {
          recordingId: this.$route.params.id,
          participantId: item.id,
        })
        .finally(() => {
          this.toastMsg(
            `Você deixou a participação de "${item.name}" como pendente.`
          );
          this.setWaiting(item.id, false);
        });
    },
    removeParticipant(item) {
      this.setWaiting(item.id, true);
      this.$store
        .dispatch("recording/removeParticipant", {
          recordingId: this.$route.params.id,
          participantId: item.id,
        })
        .finally(() => {
          this.$emit("refreshItems");
          this.setWaiting(item.id, false);
          this.toastMsg(
            `Você removeu "${item.name}" da lista de participantes.`
          );
        });
    },
    removeInviteWelcome(item) {
      if (item.invitees) {
        item.invitees.map((item) => {
          this.$store
            .dispatch("recording/removeInviteWelcome", {
              inviteeId: item.id,
              recording: 1,
            })
            .finally(() => {});
        });
      }
    },
    toastMsg(msg, success = true) {
      this.$vs.notify({
        text: msg,
        color: success ? "success" : "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
        time: 10000,
        position: "bottom-left",
      });
    },
  },
  filters: {
    formatDate: function (date) {
      if (!date) return;
      return date.replace(/(\d{4})-(\d{2})-(\d{2})/, "$3/$2/$1");
    },
    calculateAge(date) {
      if (!date) return "";
      var ageDifMs = Date.now() - new Date(date).getTime();
      var ageDate = new Date(ageDifMs);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    },
    formatGender: (value) => {
      if (!value) return "";
      switch (value) {
        case "male":
          return "Masc...";
        case "female":
        case "feminine":
          return "Femin..";
        default:
          return "Outros";
      }
    },
    firstLetter: (value) => {
      if (!value) return "";
      return String(value[0] || " ").toUpperCase();
    },
    formatCelphone: (value) => {
      if (!value) return "";
      return value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.participant-checkin-ok {
  background: #6ddb7c;
  color: #fff;
  text-align: center;
  border-radius: 2px;
  margin-top: 2px;
}
.participant-checkin-no-ok {
  background: orange !important;
  color: rgb(110, 66, 0);
  text-align: center;
  border-radius: 2px;
  margin-top: 2px;
}
.img-container img {
  border-radius: 6px !important;
  width: 50px !important;
  height: 50px !important;
  background-color: #ddd;
}
.col-photo-part {
  width: 64px;
  height: 64px;
  display: flex;
}
.col-description-part {
  display: flex;
  flex: 1;
  flex-direction: column;
}

.row-name {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 17px;
}
.participant-name {
  font-weight: bold;
  color: #000;
}
.trash-icon-div {
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #999;
  background-color: #fff;
  width: 36px;
  height: 36px;
  border-radius: 5px;
  margin-left: 4px;
}

#data-recordings-list-view {
  .cardlist-row-name {
    .item-title {
      margin: -4px 0 5px;
    }
  }
}
.note {
  font-size: 12px;
}

.status-text {
  padding-left: 4px;
}

.item-text {
  word-wrap: break-word;
}
</style>
